export default "__VITE_ASSET__DOiL_MK7__"